module.exports = __webpack_public_path__ + "static/media/about.0f518973.png";